import React, { useRef } from "react";
import SignatureCanvas from "react-signature-canvas";

const DigitalSignatureWithGDPR = ({ onSignatureChange }) => {
  const signaturePad = useRef(null);

  // Clear the signature pad and notify parent
  const clearSignature = () => {
    signaturePad.current.clear();
    if (onSignatureChange) onSignatureChange("");
  };

  // Notify parent whenever signature changes
  const handleEnd = () => {
    if (!signaturePad.current.isEmpty()) {
      const dataUrl = signaturePad.current.getTrimmedCanvas().toDataURL("image/png");
      if (onSignatureChange) onSignatureChange(dataUrl);
    } else {
      if (onSignatureChange) onSignatureChange("");
    }
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-lg">
      {/* GDPR Compliance Notice */}
      <h2 className="text-lg font-semibold mb-4">Digital Signature - Employee</h2>
      <div className="mb-4">
        <p className="text-sm text-gray-700">
          By signing this form, you confirm that the information you have provided regarding your recent sickness absence is true and complete to the best of your knowledge.
        </p>
        <p className="text-sm text-gray-700 mt-2">
          You also acknowledge and agree that:
        </p>
        <ul className="list-disc list-inside text-sm text-gray-700 mt-2">
          <li>You are fit to return to work, unless otherwise stated on this form..</li>
          <li>You understand that providing false or misleading information may result in disciplinary action, in line with company policy.</li>
          <li>You consent to this information being securely stored and processed as part of your employment record.</li>
          <li>Your data will only be used for legitimate employment and health & safety purposes, and will not be shared without your consent.</li>
        </ul>
        <p className="text-sm text-gray-700 mt-2">
          This declaration forms part of your formal return-to-work process.
        </p>
      </div>

      {/* Signature Canvas */}
      <SignatureCanvas
        ref={signaturePad}
        penColor="black"
        onEnd={handleEnd}
        canvasProps={{
          className: "w-full h-48 border border-gray-300 rounded-lg",
        }}
      />

      {/* Action Buttons */}
      <div className="flex justify-end mt-4">
        <button
          onClick={clearSignature}
          className="bg-gray-500 text-white px-4 py-2 rounded-md hover:bg-gray-600"
        >
          Clear
        </button>
      </div>
    </div>
  );
};

export default DigitalSignatureWithGDPR;
